export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 2_02.09f5f949.jpg";